import { render, staticRenderFns } from "./Merchantcount.vue?vue&type=template&id=37e68476&"
import script from "./Merchantcount.vue?vue&type=script&lang=js&"
export * from "./Merchantcount.vue?vue&type=script&lang=js&"
import style0 from "./Merchantcount.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports